import React, {useEffect, useState} from "react"
import {FunctionComponent} from "react"
import ComponentWrapper from "../../../common/components/ComponentWrapper"
import {useNavigate} from "react-router-dom"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import {useGetCustomerBlocks, useGetRequirementCategories} from "../api/queries"
import {translateConstantsWithBackendTranslations} from "../../../common/services/translationService"
import {RequirementCategories} from "@murphy-frontend/web-core/constants"
import CategoryIcons from "@murphy-frontend/web-core/components/CategoryIcons"
import Spinner from "@murphy-frontend/web-core/components/Spinner"
import Button from "@murphy-frontend/web-core/components/Button"
import {IoChevronBackOutline} from "react-icons/io5"
import {IconContext} from "react-icons"

interface AssessmentProps {}

const StartAssessment: FunctionComponent<AssessmentProps> = () => {
	const navigate = useNavigate()
	const {customer} = useCustomer()
	const {translations} = useUserPreferences()

	const {data: customerBlocks, isLoading: customerBlocksIsLoading} = useGetCustomerBlocks(customer.Id)
	const {data: requirementCategories, isLoading: requirmentCategoriesIsLoading} = useGetRequirementCategories()
	const translatedRequirementCategories = translateConstantsWithBackendTranslations(
		RequirementCategories,
		translations
	)

	if (requirmentCategoriesIsLoading || customerBlocksIsLoading) {
		return (
			<ComponentWrapper active={3} subMenuActive={2}>
				<div className='spinner-container-global-center'>
					<Spinner />
				</div>
			</ComponentWrapper>
		)
	}

	return (
		<ComponentWrapper active={3}>
			<section className='header-btns'>
				<div className='header-back-btn'>
					<Button buttonSize={"btn--medium"} isLightButton={true} onClick={() => navigate(`/portal`)}>
						<IconContext.Provider value={{className: "btn-icon"}}>
							<IoChevronBackOutline />
						</IconContext.Provider>
						&nbsp; {translations.back}
					</Button>
				</div>
				<div className='header-right-btn'>
					<Button buttonSize={"btn--medium"} isLightButton={true} onClick={() => navigate(`/tmsparentdashboard`)}>
						{translations.skipAssessment}
					</Button>
				</div>
			</section>
			<section className='general-wrapper'>
				<h1 className='assessment_title'>{translations.questionHelpUs || 'Help us help you'}</h1>
				<p className='assessment_subttext'>
					{translations.fiveTopics || 'The questionnaire will evaluate the 5 topics that makes up your organization’s crisis management capacity, which we call the <strong>&nbsp; 5 Foundations.</strong>'}
				</p>
				<div className='assessment-row'>
					{requirementCategories.map(cat => (
						<div className='cat-list'>
							<CategoryIcons categoryId={cat.Id} />
							<div>{translatedRequirementCategories.find(el => el.id === cat.Id).value}</div>
						</div>
					))}
				</div>
				<p className='assessment_subttext'>
					{translations.simpleAnswer || 'Simply answer the following questionnaire to the best of your knowledge. You will be able to update your answers later.'}
				</p>
				<Button
					buttonStyle={"btn--primary"}
					buttonSize={"btn--medium"}
					onClick={() => navigate(`/questionnaire/${customer.Id}/${customerBlocks[0].Id}?survey=true`)}
				>
					{translations.startWith} &nbsp;<strong>{translatedRequirementCategories[0].value}</strong>
				</Button>
			</section>
		</ComponentWrapper>
	)
}

export default StartAssessment
